import { SpyneTrait } from "spyne";
import { AuthViewProfileListItem } from "components/auth/auth-view-profile-list-item";

export class AuthViewTraits extends SpyneTrait {
  constructor(context) {
    let traitPrefix = "authView$";
    super(context, traitPrefix);
  }

  static authView$HelloWorld() {
    return "Hello World";
  }

  static authView$SetProfileData(data=props.data) {
    const proButton = `<button data-event-type="authEvent" data-is-pricing-event="true" data-pricing-type="manageSettings"><i class="fa-sharp fa-thin fa-gear"></i><span>Settings</span></button>`;


    const freeButton = `<button  data-event-type="authEvent" data-is-pricing-event="true" data-pricing-type="pro" >
    <i class="fa-sharp fa-thin fa-arrow-up-from-line"></i><p>Upgrade</p></button>`;

    const roleNameHash = {
      free: 'Free',
      premium: 'Pro',
    };
    const {role} = data;

    const roleName = roleNameHash[role] || 'Free';

    data['roleName'] = roleName;
    data['roleButton'] = String(role).toLowerCase() === 'premium' ? proButton : freeButton;

    return data;

  }

  static authView$AddListItems(data = this.props.data) {
    const { userApps } = data;

    const addItem = (data) => {
      this.appendView(new AuthViewProfileListItem({ data }));
    };
    userApps.forEach(addItem);
  }
}
